import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionPillar from "@/pages/SolutionPillar";

export const Route = createFileRoute("/zh-cn/solutions/$pillarSlug")({
  head: ({ params }) => buildRouteHead(`/zh-cn/solutions/${params.pillarSlug}`),
  component: SolutionPillar,
});

